import { defineStore } from "pinia";

import {
  defaultAnalyticsFilters,
  type AnalyticsFilters,
  type AnalyticsViewModel,
} from "./models.js";
import type { AnalyticsService } from "./service.js";

export const useAnalyticsStore = defineStore("merchant-analytics", {
  state: (): {
    errorMessage?: string;
    filters: AnalyticsFilters;
    loading: boolean;
    service?: AnalyticsService;
    view?: AnalyticsViewModel;
  } => ({
    filters: defaultAnalyticsFilters(),
    loading: false,
  }),
  actions: {
    configure(service: AnalyticsService): void {
      this.service = service;
    },
    async load(filters: AnalyticsFilters): Promise<void> {
      this.filters = filters;
      this.loading = true;
      delete this.errorMessage;
      try {
        this.view = await this.requireService().loadAnalytics(filters);
      } catch (error: unknown) {
        this.errorMessage =
          error instanceof Error ? error.message : "Analytics could not be loaded.";
      } finally {
        this.loading = false;
      }
    },
    requireService(): AnalyticsService {
      if (this.service === undefined)
        throw new Error("Analytics store was not configured before use.");
      return this.service;
    },
  },
});

export { defaultAnalyticsFilters };
